import { Form, Input, Select } from "antd";
import Button from "../../Atoms/Button/Button";
import FormBox from "../../Atoms/FormBox/FormBox";
import FormTitle from "../../Atoms/FormTitle/FormTitle";
import InputFormContainer from "../../Atoms/InputFormContainer/InputFormContainer";
import Modal from "../Modal/Modal";
import iconProfileCreate from '../../../assets/iconProfileCreate.svg'
import { useLocation } from "wouter";
import { useModal } from "../../../customHooks/useModal";
import { useState } from "react";
const { Option } = Select;

const FormPersonalData = () => {
  const [isOpenModal, openModal, closeModal] = useModal(false)
  const [form] = Form.useForm();
  const [, setLocation ] = useLocation();
  const [disabledInput, setDisabledInput] = useState(false)

  const sendForm = (e) => {
    console.log(e);
    openModal()
  };

  const clearForm = () => {
    form.resetFields()
    closeModal()
  }

  const goToDashboard = () => {
    closeModal()
    setLocation('/dashboard')
  }

  return (
    <>
     <div className={`buttons-container mt-30`}>
      <button onClick={() => setDisabledInput(false)} disabled={!disabledInput} className="button s-large m-auto grayColor outline">Cancelar Edición</button>
      <button onClick={() => setDisabledInput(true)} disabled={disabledInput} className="button s-large m-auto grayColor">Editar información</button>
    </div>
    <Form onFinish={sendForm} form={form}  >
      <FormBox>
        <FormTitle text="Representante de la empresa" />

        <InputFormContainer label="Nombre:" indentificador="nombre">
          <Form.Item
            name="nombre"
            rules={[{ required: true, message: "Por favor ingresa tu nombre" }]}
          >
            <Input size="large" placeholder="José Alejandro" disabled={!disabledInput} />
          </Form.Item>
        </InputFormContainer>

        <InputFormContainer label="Apellido:" indentificador="apellido">
          <Form.Item
            name="apellido"
            rules={[
              { required: true, message: "Por favor ingresa tu apellido" },
            ]}
          >
            <Input size="large" placeholder="Gonzáles" disabled={!disabledInput} />
          </Form.Item>
        </InputFormContainer>

        <InputFormContainer label="Edad:" indentificador="edad">
          <Form.Item
            name="edad"
            rules={[{ required: true, message: "Por favor ingresa tu edad" }]}
          >
            <Select placeholder="Edad" size="large" disabled={!disabledInput}>
              <Option value={18}>18</Option>
              <Option value={19}>19</Option>
              <Option value={20}>20</Option>
              <Option value={21}>21</Option>
              <Option value={22}>22</Option>
            </Select>
          </Form.Item>
        </InputFormContainer>

        <InputFormContainer label="Género:" indentificador="genero">
          <Form.Item
            name="genero"
            rules={[{ required: true, message: "Por favor ingresa tu genero" }]}
          >
            <Select placeholder="Género" size="large" disabled={!disabledInput}>
              <Option value={18}>Mujer</Option>
              <Option value={19}>Hombre</Option>
            </Select>
          </Form.Item>
        </InputFormContainer>

        {/* PARTE 2 */}

        <FormTitle text="Datos de contacto" />

        <InputFormContainer
          label="Email personal:"
          indentificador="email_personal"
        >
          <Form.Item
            name="email_personal"
            rules={[
              {
                required: true,
                message: "Por favor ingresa tu email personal!",
              },
            ]}
          >
            <Input size="large" placeholder="login@email.com" disabled={!disabledInput} />
          </Form.Item>
        </InputFormContainer>

        <InputFormContainer label="Móvil:" indentificador="movil">
          <Form.Item
            name="movil"
            rules={[
              {
                required: true,
                message: "Por favor ingresa tu movil!",
              },
            ]}
          >
            <Input size="large" placeholder="04245374810" disabled={!disabledInput} />
          </Form.Item>
        </InputFormContainer>

        <InputFormContainer label="País:" indentificador="pais">
          <Form.Item
            name="pais"
            rules={[
              {
                required: true,
                message: "Por favor ingresa tu email pais!",
              },
            ]}
          >
            <Select size="large" placeholder="Venezuela" disabled={!disabledInput}>
              <Option value="venezuela">Venezuela</Option>
            </Select>
          </Form.Item>
        </InputFormContainer>

        <InputFormContainer label="Ciudad:" indentificador="ciudad">
          <Form.Item
            name="ciudad"
            rules={[
              {
                required: true,
                message: "Por favor ingresa tu email ciudad!",
              },
            ]}
          >
            <Input size="large" placeholder="Indica tu ciudad" disabled={!disabledInput} />
          </Form.Item>
        </InputFormContainer>

        <InputFormContainer
          label="Dirección:"
          indentificador="direccion"
          spanTwo
        >
          <Form.Item
            name="direccion"
            rules={[
              {
                required: true,
                message: "Por favor ingresa tu email direccion!",
              },
            ]}
          >
            <Input size="large" placeholder="Indica tu ciudad" disabled={!disabledInput} />
          </Form.Item>
        </InputFormContainer>

        {/* Parte 3 */}

        <FormTitle text="Datos laborales" />

        <InputFormContainer
          label="Email de empresa:"
          indentificador="email_empresa"
        >
          <Form.Item
            name="email_empresa"
            rules={[
              {
                required: true,
                message: "Por favor ingresa el email de tu empresa!",
              },
            ]}
          >
            <Input size="large" placeholder="login@email.com" disabled={!disabledInput} />
          </Form.Item>
        </InputFormContainer>

        <InputFormContainer
          label="Cargo o posición en la empresa:"
          indentificador="cargo"
        >
          <Form.Item
            name="cargo"
            rules={[
              {
                required: true,
                message: "Por favor ingresa tu cargo!",
              },
            ]}
          >
            <Select placeholder="Coordinador" size="large" disabled={!disabledInput}>
              <Option value="coordinador">Coordinador</Option>
            </Select>
          </Form.Item>
        </InputFormContainer>

        <InputFormContainer
          label="Móvil de empresa:"
          indentificador="movil_empresa"
        >
          <Form.Item
            name="movil_empresa"
            rules={[
              {
                required: true,
                message: "Por favor ingresa tu movil de empresa!",
              },
            ]}
          >
            <Input size="large" placeholder="04245374810" disabled={!disabledInput} />
          </Form.Item>
        </InputFormContainer>

        <InputFormContainer
          label="Grupo de trabajo:"
          indentificador="grupo_trabajo"
        >
          <Form.Item
            name="grupo_trabajo"
            rules={[
              {
                required: true,
                message: "Por favor ingresa tu grupo de trabajo!",
              },
            ]}
          >
            <Select placeholder="Por área" size="large" disabled={!disabledInput} >
              <Option value="coordinador">Por área</Option>
            </Select>
          </Form.Item>
        </InputFormContainer>

        <div className={`buttons-container mt-30 m-cols-2`}>
          <button disabled={!disabledInput} className="button s-large m-auto primary">Actualizar información</button>
        </div>

      </FormBox>
    </Form>

    <Modal
      isOpenModal={isOpenModal} 
      iconModal={iconProfileCreate}
      titleModal="Genial" 
      closeModal={() => closeModal()}
      subTitleModal="Se ha actualizado / creado tu información personal correctamente. Un correo llegará a tu bandeja, debes confirmarlo para continuar el proceso.">    
       <div className="buttons-container center mt-20">
          <Button content="Ir al dashboard" type="primary" customClass="s-large m-auto" clickHandler={() => goToDashboard()}/>
          <Button content="Cerrar" type="primary outline" customClass="s-large m-auto" clickHandler={clearForm}  />
       </div>
    </Modal>    
    </>
  );
};

export default FormPersonalData;
